import { getCookie, removeCookie, setCookie } from '@guardian/libs';
const USER_FEATURES_EXPIRY_COOKIE = 'gu_user_features_expiry';
export const getUserFeaturesExpiryCookie = () => getCookie({ name: USER_FEATURES_EXPIRY_COOKIE });
export const setUserFeaturesExpiryCookie = (expiryTime) => setCookie({ name: USER_FEATURES_EXPIRY_COOKIE, value: expiryTime });
export const removeUserFeaturesExpiryCookie = () => removeCookie({ name: USER_FEATURES_EXPIRY_COOKIE });
export const featuresDataIsOld = () => {
    const cookie = getUserFeaturesExpiryCookie();
    if (!cookie)
        return true;
    const expiryTime = parseInt(cookie, 10);
    const timeNow = new Date().getTime();
    return timeNow >= expiryTime;
};
